<template>
  <div>
    <div class="timeline">
      <div v-for="(item, index) in stepItems" :key="index" class="timeline-item">
        <div class="timeline-dot"></div>
        <div class="timeline-line" v-if="index < stepItems.length - 1"></div>
        <div class="timeline-content">
          <span class="timeline-time">{{ item.time }}</span>
          <span class="timeline-des">{{ item.des }}</span>
        </div>
      </div>
    </div>
    <div v-if="stepItems?.length === 0" class="info-text">暂无操作历史数据</div>
  </div>
</template>

<script>
export default {
  name: 'SaleOrderTimeline',
  props: {
    stepItems: Array,
  },
};
</script>

<style scoped>
.timeline {
  position: relative;
  padding: 0;
}

.timeline > *:not(:first-child) {
  margin-top: -12px;
}

.timeline-item {
  position: relative;
  padding-left: 8px;
  display: flex;
  align-items: center;
}

.timeline-dot {
  position: absolute;
  left: 0;
  top: 30%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  background-color: #6395d6;
  border-radius: 50%;
  z-index: 2;
}

.timeline-line {
  position: absolute;
  left: 3px;
  top: 10px;
  width: 2px;
  height: calc(100% - 10px);
  background-color: #ddd;
}

.timeline-content {
  margin-left: 20px;
  display: flex;
  align-items: center;
  padding-bottom: 20px;
}

.timeline-time {
  font-size: 14px;
  color: #aaa;
  margin-right: 10px;
  width: 150px; /* 设置固定宽度 */
}

.timeline-des {
  font-size: 16px;
  color: #333;
}
</style>
